import React from "react";
import about from "../../assets/About.jpg";

const About = () => {
  return (
    <div className="section" id="about">
      <div className="grid md:grid-cols-2 gap-8 place-items-center">
        <div className="border-[3px] border-solid border-Teal rounded-lg">
          <img src={about} alt="" className="p-4" />
        </div>
        <div>
          <div className="font-bold sm:text-[1.875rem] text-[1.5rem] mb-5">
            We provide the <br /> best{" "}
            <span className="text-Teal">offline classes</span>
          </div>
          <p className="text-sm text-gray leading-7 mb-4">
            MTZIC Education offers unparalleled offline classes tailored to your
            needs. Our expert instructors deliver top-quality instruction across
            various subjects, ensuring success in exams and skill development.
            Join us for transformative learning experiences that unlock your
            potential. Enroll now and experience the difference at MTZIC
            Education.
          </p>
          <button className="py-3 px-6 text-sm border border-solid border-gray rounded-lg font-bold">
            Know More
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
